/**
 * Mobile nav custom JS
 */

document.addEventListener("DOMContentLoaded", () => {
  const mobileMenu = document.querySelector(".main-nav__mobile");
  const mobileNavContainer = document.querySelector("#mobile-nav-container");
  const allMobileNavLinks = document.querySelectorAll("#mobile-nav-container ul a[href]");
  const hamburgerBtn = mobileMenu.querySelector(".main-nav__mobile-hamburger");
  const closeBtn = mobileMenu.querySelector(".main-nav__mobile-close");
  const enveloLogo = document.querySelector(".main-nav__logo");
  const accordionsForMenuLvl2 = document.querySelectorAll('#main-menu-mobile>li.menu-item-has-children');
  const mobileMediaQuery = window.matchMedia('(width < 1200px)');

  // Functions which handle open/close mobile menu
  const closeMobileMenu = () => {
    mobileMenu.removeAttribute("open");
    hamburgerBtn.setAttribute('aria-expanded', 'false');
    mobileNavContainer.setAttribute('inert', '');
  }

  const openMobileMenu = () => {
    mobileMenu.setAttribute('open', '');
    hamburgerBtn.setAttribute('aria-expanded', 'true');
    mobileNavContainer.removeAttribute('inert');
  }

  hamburgerBtn?.addEventListener("click", openMobileMenu);
  closeBtn?.addEventListener("click", closeMobileMenu);
  enveloLogo?.addEventListener("focus", closeMobileMenu);

  document.addEventListener("keydown", (e) => {
    if (e.key == "Escape") {
      closeMobileMenu();
    }
  });

  window.addEventListener("click", (event) => {
    if (
      document.querySelector(".main-nav__mobile[open]") &&
      !mobileMenu.contains(event.target)
    ) {
      closeMobileMenu();
    }
  });

  allMobileNavLinks.forEach(mobileNavLink => { 
    mobileNavLink.addEventListener('click', closeMobileMenu);
  })

  // Set initial mobile menu layout
  // Expand accordion if lvl 2 element is active
  const initMobileMenuLayout = (media) => {
    const isMobile = media.matches;

    if (isMobile) {
      accordionsForMenuLvl2.forEach(acc => {
        expandAccordionForCurrentPage(acc);
      });
      mobileNavContainer.setAttribute('inert', '');
    } else {
      mobileNavContainer.removeAttribute('inert');
    }

  };

  // Expand accordion for current page
  const expandAccordionForCurrentPage = (acc) => {
    const currentAccContent = acc.querySelector('.sub-menu-wrapper.menu-lvl-2');
    const currentAccController = acc.querySelector('button');
    
    if (['current-menu-parent', 'current-menu-item', 'current-page-ancestor', 'active'].some(classItem => acc.classList.contains(classItem))) {
      const currAccHeight = currentAccContent.scrollHeight;
      currentAccContent.style.height = currAccHeight + "px";
      acc.classList.add('active');
      currentAccController.setAttribute('aria-expanded', 'true');
    } else {
      currentAccContent.style.height = "0px";
    }
  }

  // Make menu with available lvl 2 work like accordion
  const handleAccClickAction = (acc) => {
    const currentAccContent = acc.querySelector('.sub-menu-wrapper.menu-lvl-2');
    const currentAccController = acc.querySelector('button');

    if (acc.classList.contains('active')) {
      currentAccContent.style.height = "0px";
      acc.classList.remove('active');
      currentAccController.setAttribute('aria-expanded', 'false');
    } else {
      accordionsForMenuLvl2.forEach((menuLvl2ToClose) => {
        menuLvl2ToClose.classList.remove('active');
        menuLvl2ToClose.querySelector('button')?.setAttribute('aria-expanded', 'false');
        menuLvl2ToClose.querySelector('.sub-menu-wrapper.menu-lvl-2').style.height = "0px";
      });

      const currAccHeight = currentAccContent.scrollHeight;
      currentAccContent.style.height = currAccHeight + "px";
      acc.classList.add("active");
      currentAccController.setAttribute('aria-expanded', 'true');

    }
  }

  // Add functionality for every menu lvl 2 element
  accordionsForMenuLvl2.forEach(acc => {
    const accBtn = acc.querySelector('a');

    accBtn.addEventListener('click', () => {
      handleAccClickAction(acc);
    });

    acc.addEventListener("keydown", (event) => {
      if (event.key === " ") {
        handleAccClickAction(acc);
      }
    });

    expandAccordionForCurrentPage(acc);
  });

  // Init layout of mobile menu on load and when mobileMediaQuery variable changes
  initMobileMenuLayout(mobileMediaQuery);
  mobileMediaQuery.addEventListener("change", (e) => 
    initMobileMenuLayout(e)
  );
});
